import { render, staticRenderFns } from "./singleSourceCreate.vue?vue&type=template&id=09674e78&scoped=true"
import script from "./singleSourceCreate.vue?vue&type=script&lang=js"
export * from "./singleSourceCreate.vue?vue&type=script&lang=js"
import style0 from "./singleSourceCreate.vue?vue&type=style&index=0&id=09674e78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09674e78",
  null
  
)

export default component.exports